@if (data$ | async; as data) {
  <app-alerts />

  <app-admin-invoice-settings-form
    [data]="data"
    (submitClickEvent)="handleSubmitClick($event)" />
} @else {
  <app-spinner-filled />
}
